import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    denominacion: Yup.string().matches(/^[a-zA-Z0-9\s]*$/, 'Solo se permiten letras, números y espacios').required('La denominación debe ser obligatoria'),
    capacidad: Yup.number().typeError("La capacidad debe ser un número"),
})